var map = {
	"./am-bumen.svg": "lyfK",
	"./am-diary.svg": "3uBE",
	"./am-guanli.svg": "Fkl4",
	"./am.svg": "Zk2g",
	"./cms-area.svg": "Yoxv",
	"./cms-question.svg": "FXal",
	"./cms.svg": "fHET",
	"./dms-list.svg": "LfwA",
	"./dms-money.svg": "LW2B",
	"./dms-setting.svg": "x+fA",
	"./dms-withdraw.svg": "vYTH",
	"./dms.svg": "h/ab",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./freight.svg": "wbuy",
	"./home.svg": "U9Ws",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./mms-analysis.svg": "HmVO",
	"./mms-list.svg": "yVwC",
	"./mms.svg": "3QCR",
	"./oms-company.svg": "0Stj",
	"./oms-delivery.svg": "47OQ",
	"./oms-list.svg": "KsrN",
	"./oms-tuikuan.svg": "fX8E",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./pm-tubiao.svg": "kCg5",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-discount.svg": "cDZD",
	"./sms-flash.svg": "/KjT",
	"./sms-group.svg": "twRl",
	"./sms-hot.svg": "If2y",
	"./sms-mall.svg": "Nxn4",
	"./sms-nav.svg": "geE8",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./store-list.svg": "Lwy5",
	"./store-list2.svg": "yCg2",
	"./store.svg": "Lta+",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 158